<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'manage_reservations' | translate}}</h3>
      </div>
      <div class="box-controls">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
        <div class="row">
        </div>
      </div>
      <div class="box-body">
        <click-collect-table :orders="pagination.data" @sort="sort($event)"></click-collect-table>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </section>
</template>
<script>
import DateRangePicker from '../tools/DateRangePicker.vue'
export default {
  name: 'OrdersOverview',
  data () {
    return {
      alerts: [],
      selectedStatus: window.localStorage.getItem('orderStatus') ? window.localStorage.getItem('orderStatus') : 'open',
      selectedChannel: window.localStorage.getItem('orderChannel') ? window.localStorage.getItem('orderChannel') : '',
      selectedSku: window.localStorage.getItem('orderSku') ? window.localStorage.getItem('orderSku') : '',
      selectedQBId: window.localStorage.getItem('orderQBId') ? window.localStorage.getItem('orderQBId') : '',
      selectedUsername: window.localStorage.getItem('orderUsername') ? window.localStorage.getItem('orderUsername') : '',
      selectedStart: window.localStorage.getItem('selectedStart') ? window.localStorage.getItem('selectedStart') : '',
      selectedEnd: window.localStorage.getItem('selectedEnd') ? window.localStorage.getItem('selectedEnd') : '',
      sortType: window.localStorage.getItem('sortType') ? window.localStorage.getItem('sortType') : 'asc',
      dateRange: 'ciao',
      channels: [{label: 'all', val: 0}, {label: 'schuhe.de', val: 1}, {label: 'schuhe.de-ebay', val: 2}, {label: 'schuhe.de-zalando', val: 3}, {label: 'schuhe.de-amazon', val: 4}, {label: 'schuhe.de-spartoo', val: 10}],
      statusArray: ['all', 'open', 'shipped', 'returned', 'canceled', 'mp_cancellation', 'reserved', 'customer_cancellation'],
      startRange: window.localStorage.getItem('selectedStart') ? moment(window.localStorage.getItem('selectedStart')) : moment().subtract(1, 'month'),
      endRange: window.localStorage.getItem('selectedEnd') ? moment(window.localStorage.getItem('selectedEnd')) : moment(),
      picklist: [],
      products: {},
      channel: 0,
      returns: 0,
      newItems: 0,
      canceled: 0,
      shipped: 0,
      initials: 0,
      open: 0,
      mpCancel: 0,
      customerCancel: 0,
      statuses: [],
      isActive: '',
      sellOnline: '',
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0
      },
      backup: [],
      paginate (type, value) {
        let url = '?preflight=kek'
        if (type === 'page') {
          url += '&page='
          if (value === 'previous') {
            url += (this.pagination.current_page - 1)
          }
          if (value === 'next') {
            url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
          } else if (value !== 'next' && value !== 'previous') {
            url += value
          }
        }
        url += `&start=${this.selectedStart}&end=${this.selectedEnd}`
        url += `&sort=${this.sortType}`
        url += `&ext_order_id=${this.selectedSku}`
        url += `&sales_channel_id=${this.selectedChannel}`
        url += `&status=${this.selectedStatus}`
        url += `&qb_id=${this.selectedQBId}`
        url += `&last_name=${this.selectedUsername}`
        window.localStorage.setItem('orderChannel', this.selectedChannel)
        window.localStorage.setItem('orderStatus', this.selectedStatus)
        window.localStorage.setItem('orderSku', this.selectedSku)
        window.localStorage.setItem('orderQBId', this.selectedQBId)
        window.localStorage.setItem('orderUsername', this.selectedUsername)
        window.localStorage.setItem('sortType', this.sortType)
        window.localStorage.setItem('selectedEnd', this.selectedEnd)
        window.localStorage.setItem('selectedStart', this.selectedStart)
        API.get(`/clickAndCollect${url}`)
          .then(response => {
            this.pagination = response.data
            this.pagination.data.forEach(o => {
              o.date_order = o.date_order.split(' ')
              o.date_order[0] = o.date_order[0].split('-').reverse().join('.')
              o.date_order = o.date_order.join(' ')
            })
            window.localStorage.setItem('orderPage', this.pagination.current_page)
            this.filterStatus()
          }, error => {
            if (this.$store.dispatch('checkError', error)) {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              this.$store.commit('pushAlert', alert)
            } else this.$router.push('/unauthorized')
          })
      }
    }
  },
  components: {
    dateRangePicker: DateRangePicker
  },
  methods: {
    triggerStatus (status) {
      this.selectedStatus = status
      this.paginate('status')
    },
    filterOrders (event) {
      let orders = this.backup
      let status = ''
      this.pagination.data = []
      switch (event) {
        case 1:
          status = 'processing'
          break
        case 2:
          status = 'shipped'
          break
        case 3:
          status = 'returned'
          break
        case 4:
          status = 'canceled'
          break
        default:
          this.pagination.data = this.backup
          break
      }
      for (let x in orders) {
        for (let y in orders[x].status) {
          if (orders[x].status[y].label === status && status !== '') {
            this.pagination.data.push(orders[x])
          }
        }
      }
    },
    onDateRangeChanged (picker) {
      this.dateRange = `${picker.startDate} - ${picker.endDate}`
      this.startRange = picker.startDate
      this.endRange = picker.endDate
      this.selectedEnd = this.endRange.format('YYYY-MM-DD')
      this.selectedStart = this.startRange.format('YYYY-MM-DD')
      this.paginate('', '')
    },
    getStatus (label, id) {
      if (id === 1 || id === 2 || id === 5 || id === 6) {
        return {label: label, style: 'label label-success', icon: 'fa fa-check mr-5'}
      } else if (id === 7) {
        return {label: label, style: 'label label-info', icon: 'fa fa-check-circle mr-5'}
      } else {
        return {label: label, style: 'label label-danger', icon: 'fa fa-ban mr-5'}
      }
    },
    filterStatus () {
      let orders = this.pagination.data
      for (let x in orders) {
        orders[x].status = this.getStatus(orders[x].status, orders[x].status_id)
      }
    },
    sort (value) {
      this.sortType = value
      this.paginate('', '')
    }
  },
  mounted () {
    this.$nextTick(() => {
      let url = '?page=' + window.localStorage.getItem('orderPage')
      if (this.$store.dispatch('checkPermissions', 'co_products')) {
        API.get(`/clickAndCollect${url}`)
          .then(response => {
            this.pagination = response.data
            this.backup = response.data.data
            this.pagination.data.forEach(o => {
              o.date_order = o.date_order.split(' ')
              o.date_order[0] = o.date_order[0].split('-').reverse().join('.')
              o.date_order = o.date_order.join(' ')
            })
            this.filterStatus()
          }, error => {
            if (this.$store.dispatch('checkError', error)) {
              let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message]}
              this.$store.commit('pushAlert', alert)
            } else this.$router.push('/unauthorized')
          })
      } else {
        this.$router.push('/unauthorized')
      }
    })
  }
}
</script>
<style>
  select option.normal{margin:40px;color:#fff;text-shadow:0 1px 0 rgba(0,0,0,.4)}select option.normal{background:#202227}
</style>



// WEBPACK FOOTER //
// src/components/views/ClickCollectOverview.vue